import { Dispatch } from 'redux';
import { axiosInstance, request } from './base';
import { LancamentoStatus, type LiquidacaoData } from 'pages/liquidacoes';
import { InstrumentoFinanceiro, type IPaginatedData } from 'common/genericTypes';

export interface LiquidacaoComprovanteDTO {
    dataOperacao: Date,
    tipoInstrumentoFinanceiro: InstrumentoFinanceiro, 
    codigo: string,
    codigoOperacao: string,
    codigoExterno: string,
    emissor: string,
    cpfCnpjEmissor: string,
    quantidade: number,
    precoNominalUnitario: number,
    precoTotal: number,
    tipoOperacao: string,
    codigoOperacaoExterno: TiposOperacaoEnum,
    investidor: string,
    cpfCnpjInvestidor: string,
    bancoOrigem: string,
    bancoDestino: string,
    situacao: LancamentoStatus,
    dataLiquidacao: Date | null,
    modalidade: string
}

export enum TiposOperacaoEnum {
    JUROS = 9000,
    AMORTIZACAO = 9001,
    PREMIO = 9002,
    RESGATE_VENCIMENTO = 9003,
    MULTA_E_MORA = 9004,
    AMORTIZACAO_EXTRAORDINARIA = 9005,
    RESGATE_ANTECIPADO = 9006,
    COMPRA_E_VENDA = 9007
}

export const POSTComprovante = async (dispatch: Dispatch, body: LiquidacaoComprovanteDTO, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<string>(`api/v1/liquidacoes/receipt`, body),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETLiquidacoes = async (dispatch: Dispatch, query: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<IPaginatedData<LiquidacaoData>>(`api/v1/liquidacoes?${query}`),
    dispatch,
    undefined,
    stackRequest
  );
};
